import { greyPalette, masmovilPalette, llamayaPalette, textPalette } from './colors'
import { fonts } from './fonts'

const commonAlertOverride = {
  MuiAlert: {
    root: {
      '&.loading': {
        backgroundColor: greyPalette[300],
        '& .MuiAlert-icon': {
          background: greyPalette[700],
          color: greyPalette[50],
        },
      },
      padding: '0px',
      alignItems: 'center',
      boxShadow:
        '0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14)',
    },
    icon: {
      padding: '12px 4px',
      marginRight: '16px',
      borderRadius: '4px 0 0 4px',
    },
    message: {
      fontSize: fonts.size.base,
      color: textPalette.secondary,
      marginRight: '32px',
    },
  },
}

export const masmovilAlertOverride = {
  MuiAlert: {
    ...commonAlertOverride.MuiAlert,
    standardError: {
      backgroundColor: masmovilPalette.error.disabled,
      '& .MuiAlert-icon': {
        background: masmovilPalette.error.main,
        color: greyPalette[50],
      },
    },
    standardWarning: {
      backgroundColor: masmovilPalette.warning.disabled,
      '& .MuiAlert-icon': {
        background: masmovilPalette.warning.main,
        color: greyPalette[50],
      },
    },
    standardInfo: {
      backgroundColor: masmovilPalette.info.disabled,
      '& .MuiAlert-icon': {
        background: masmovilPalette.info.main,
        color: greyPalette[50],
      },
    },
    standardSuccess: {
      backgroundColor: masmovilPalette.success.disabled,
      '& .MuiAlert-icon': {
        background: masmovilPalette.success.main,
        color: greyPalette[50],
      },
    },
  },
}

export const llamayaAlertOverride = {
  MuiAlert: {
    ...commonAlertOverride.MuiAlert,
    standardError: {
      backgroundColor: llamayaPalette.error.disabled,
      '& .MuiAlert-icon': {
        background: llamayaPalette.error.main,
        color: greyPalette[50],
      },
    },
    standardWarning: {
      backgroundColor: llamayaPalette.warning.disabled,
      '& .MuiAlert-icon': {
        background: llamayaPalette.warning.main,
        color: greyPalette[50],
      },
    },
    standardInfo: {
      backgroundColor: llamayaPalette.info.disabled,
      '& .MuiAlert-icon': {
        background: llamayaPalette.info.main,
        color: greyPalette[50],
      },
    },
    standardSuccess: {
      backgroundColor: llamayaPalette.success.disabled,
      '& .MuiAlert-icon': {
        background: llamayaPalette.success.dark,
        color: greyPalette[50],
      },
    },
  },
}
